import { graphql, Link, useStaticQuery } from "gatsby";
import { getHref } from "../getHref";
import {
  menuItemCssClasses,
  MenuItemWithSubpages,
} from "./MenuItemWithSubpages";
import { MenuItemData } from "./MenuItemsData";

interface Props {
  hideNavigationMenu: () => void;
  locationPathname: string;
}

export const MenuItems = (props: Props) => {
  const navigationMenuData = useStaticQuery<MenuItemData>(graphql`
    query MenuItemData {
      contentfulShared {
        menuItems {
          __typename
          ... on Node {
            ... on ContentfulEventPage {
              heading
              menuHeading
              slug
            }
            ... on ContentfulRegularPage {
              heading
              menuHeading
              slug
            }
            ... on ContentfulMenuItem {
              pageLink {
                __typename
                ... on ContentfulEventPage {
                  heading
                  menuHeading
                  slug
                }
                ... on ContentfulRegularPage {
                  heading
                  menuHeading
                  slug
                }
              }
              subpagesLinks {
                __typename
                ... on ContentfulEventPage {
                  heading
                  menuHeading
                  slug
                }
                ... on ContentfulRegularPage {
                  heading
                  menuHeading
                  slug
                }
              }
            }
          }
        }
      }
    }
  `);

  if (
    navigationMenuData.contentfulShared === null
    || navigationMenuData.contentfulShared.menuItems === null
  ) {
    return <></>;
  }

  const elementsArray = navigationMenuData.contentfulShared.menuItems
    .filter((menuItem) => menuItem !== null)
    .map((menuItem) => {
      switch (menuItem.__typename) {
        case "ContentfulEventPage":
        case "ContentfulRegularPage":
          return (
            <Link
              className={menuItemCssClasses}
              key={menuItem.slug}
              onClick={(event) => {
                if (getHref(menuItem) === props.locationPathname) {
                  event.preventDefault();
                  props.hideNavigationMenu();
                }
              }}
              to={getHref(menuItem)}
            >
              {menuItem.menuHeading ?? menuItem.heading}
            </Link>
          );
        case "ContentfulMenuItem":
          return (
            <MenuItemWithSubpages
              hideNavigationMenu={props.hideNavigationMenu}
              key={menuItem.pageLink?.slug}
              locationPathname={props.locationPathname}
              menuItem={menuItem}
            />
          );
      }
    });

  // Returning arrays isn't supported in functional components.
  return <>{elementsArray}</>;
};
